import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/app.css";
import "./assets/global.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "yet-another-react-lightbox/styles.css";
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import "@/assets/fa/css/all.min.css";

import store from "@/store/index";
import { persistor } from "@/store/index";
import { PersistGate } from "redux-persist/integration/react";
import Application from "./app";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Application />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
